import React, { useState, useEffect } from 'react';
import {
    PartnerSealContainer,
    SealsWrapper,
    SealImage,
    SealText,
    SealLabel,
    SealFooter,
    SealButton,
} from './partnerSealStyles';
import { getRegeneraSeal } from '../../../../../coreApi';

const PartnerSeal = () => {
    const [friendSeal, setFriendSeal] = useState(null);
    const [partnerSeal, setPartnerSeal] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchSeals = async () => {
            try {
                const sealData = await getRegeneraSeal();

                setFriendSeal(sealData.friend || null);
                setPartnerSeal(sealData.partner || null);
            } catch (error) {
                console.error('Error fetching Regenera Seals:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchSeals();
    }, []);

    const handleRedirect = () => {
        window.open(
            'https://blockscout.openprotestnet.lac-net.net/address/0x2A5612c212D75EEbc65aa197BDA6Fb4d97568E93',
            '_blank'
        );
    };

    // Hide component if partner seal is missing
    if (!partnerSeal) return null;

    return (
        <PartnerSealContainer>
            {loading ? (
                <SealText>Loading your Regenera Seals...</SealText>
            ) : (
                <>
                    <SealsWrapper>
                        {friendSeal && (
                            <div>
                                <SealImage src={friendSeal} alt="Identity NFT" />
                                <SealLabel>Identity NFT</SealLabel>
                            </div>
                        )}
                        {partnerSeal && (
                            <div>
                                <SealImage src={partnerSeal} alt="Subscription NFT" />
                                <SealLabel>Subscription NFT</SealLabel>
                            </div>
                        )}
                    </SealsWrapper>
                    <SealFooter>
                        Thank you for saving nature by subscribing to the landscape!
                    </SealFooter>
                    <SealButton onClick={handleRedirect}>View Details</SealButton>
                </>
            )}
        </PartnerSealContainer>
    );
};

export default PartnerSeal;
